/**
 * Persistence coordination seam.
 * Allows domain stores (filters, fleet, ui) to notify of state changes
 * without importing the preferences store directly, breaking circular dependencies.
 */

let scheduler: (() => void) | null = null;

export function setPreferencesSyncScheduler(fn: (() => void) | null): void {
  scheduler = fn;
}

export function triggerPreferencesSync(): void {
  if (scheduler) {
    scheduler();
  }
}
